define("shared/components/shared/post-tagging/color-circle", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <svg
    class={{concat-classes "cPT__color-icon" @class}}
    data-test-id="color-circle-svg"
    fill="none"
    height={{this.svgSize}}
    viewBox="0 0 {{this.svgSize}} {{this.svgSize}}"
    width={{this.svgSize}}
    xmlns="http://www.w3.org/2000/svg"
    ...attributes
  >
    <circle cx={{this.circleSize}} cy={{this.circleSize}} fill={{@color}} r={{this.circleSize}} />
  </svg>
  */
  {
    "id": "PRCXYEMJ",
    "block": "[[[11,\"svg\"],[16,0,[28,[37,0],[\"cPT__color-icon\",[30,1]],null]],[24,\"data-test-id\",\"color-circle-svg\"],[24,\"fill\",\"none\"],[16,\"height\",[30,0,[\"svgSize\"]]],[16,\"viewBox\",[29,[\"0 0 \",[30,0,[\"svgSize\"]],\" \",[30,0,[\"svgSize\"]]]]],[16,\"width\",[30,0,[\"svgSize\"]]],[24,\"xmlns\",\"http://www.w3.org/2000/svg\",\"http://www.w3.org/2000/xmlns/\"],[17,2],[12],[1,\"\\n  \"],[10,\"circle\"],[15,\"cx\",[30,0,[\"circleSize\"]]],[15,\"cy\",[30,0,[\"circleSize\"]]],[15,\"fill\",[30,3]],[15,\"r\",[30,0,[\"circleSize\"]]],[12],[13],[1,\"\\n\"],[13]],[\"@class\",\"&attrs\",\"@color\"],false,[\"concat-classes\"]]",
    "moduleName": "shared/components/shared/post-tagging/color-circle.hbs",
    "isStrictMode": false
  });
  class ColorCircleComponent extends _component2.default {
    get svgSize() {
      if (this.args.size) return this.args.size;
      return 8;
    }
    get circleSize() {
      return this.svgSize / 2;
    }
  }
  _exports.default = ColorCircleComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ColorCircleComponent);
});